import { useRoutes } from 'react-router-dom';

// routes
import ThemeRoutesFullLayout from './Router';
import AuthenticationRoutes from './AuthenticationRoutes';
import { useCookies } from 'react-cookie';

// ==============================|| ROUTING RENDER ||============================== //

export default function ThemeRoutes() {
  const [cookies] = useCookies(['token']);
  const token = cookies.token;

  return useRoutes([token ? ThemeRoutesFullLayout : AuthenticationRoutes], '');
}
